import styles from "./LoadingOverlay.module.css";

export default function LoadingOverlay() {
    return (<div className={styles.loadingOverlay}>
        <div role="status" className="w-16 h-16 rounded-full border-8 border-gray-800 border-r-blue-600 text-gray-200 animate-spin">
            <span class="sr-only">Loading...</span>
        </div>
    </div>)
}